import React, { useEffect, useState } from 'react'
import blogbg from '../assets/blogbg.jpg'
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
import Footer from './Footer'
import { Link, useLocation } from 'react-router-dom'
import Navigation from './Navigation'
import prod2 from "../assets/prod2.png"
import prod3 from "../assets/prod3.png"
import prod5 from "../assets/prod5.png"
import prod7 from "../assets/prod7.png"
import prod11 from "../assets/prod11.png"

const Blog = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <>
            {/* Navigation */}
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>

            {/* Banner */}
            <div className="relative">
                <img src={blogbg} alt="Background" className="w-full h-[210px] object-cover transform transition-transform duration-1000 hover:scale-105" />

                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Blog
                    </h1>
                </div>
            </div>

            {/* Breadcrumb */}
            <div className="w-full">
                <div className="flex items-center space-x-2 px-4 xl:px-20 py-5 xl:py-6">
                    <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                        <Link to="/" className="text-green-700 text-md md:text-lg">HOME</Link>
                        <MdArrowForwardIos className="text-gray-600 text-sm mt-0.5" />
                        <p className="uppercase text-md md:text-lg text-gray-700">Blog</p>
                    </div>
                </div>
                <div className="border-t border-gray-300 mx-4 xl:mx-16"></div>
            </div>

            {/* Blog Cards */}
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-4 xl:px-20 py-4 mt-5 mb-20">

                {/* Card Template */}
                {[
                    {
                        img: prod5,
                        title: "Common Devices for Addressable Systems",
                        link: "/BlogPage"
                    },

                    {
                        img: prod2,
                        title: "Fire Alarm System, N3060",
                        link: "/BlogPage2"
                    },

                    {
                        img: prod3,
                        title: "Fire Alarm System, N765",
                        link: "/BlogPage3"
                    },

                    {
                        img: prod11,
                        title: "Nitrogen Gas Suppression System",
                        link: "/BlogPage5"
                    },

                    {
                        img: prod7,
                        title: "Aspirating Super – High Sensitivity Smoke Detection System",
                        link: "/BlogPage6"
                    }

                ].map((card, index) => (
                    <div key={index} className="flex flex-col bg-white shadow rounded-md border overflow-hidden mt-6 h-full transition duration-300 hover:scale-105">

                        <Link to={card.link}>
                            <div className="relative w-full group cursor-pointer overflow-hidden px-4 -mt-8">
                                <img
                              
                                    src={card.img}
                                    alt={card.title}
                                    className="w-full h-48 md:h-52 lg:h-64 object-contain transition-transform duration-500 group-hover:scale-105" 
                                />
                                {/* <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition duration-300"></div> */}
                            </div>
                        </Link>

                        <div className="flex flex-col flex-grow px-4 xl:px-6 mb-4 -mt-2">
                            <h1 className="text-lg lg:text-xl font-semibold text-black">{card.title}</h1>

                            <div className="mt-auto">
                                <Link to={card.link}>
                                    <button className="flex items-center px-4 py-2 p-10 text-lg text-white font-medium rounded-md bg-green-700 hover:bg-green-800 transition gap-2 -mt-2">
                                        Read More
                                        <FaArrowRightLong className="w-4 h-4 mt-1" />
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

            {/* Pagination */}
            {/* <div className="flex justify-center items-center p-16">
                <div className="flex gap-4">
                    <Link to="/blog1">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog1" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>1</button>
                    </Link>
                    <Link to="/blog2">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog2" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>2</button>
                    </Link>
                    <Link to="/blog2">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog2" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>
                            <FaArrowRightLong />
                        </button>
                    </Link>
                </div>
            </div> */}

            {/* Footer */}
            <Footer />
        </>
    )
}

export default Blog


